import React, { Component } from 'react';
import './ProfilePic.css';
import Utils from '../../../base/Utils';

class ProfilePic extends Component {
    availableSizes = ['Big', 'Medium', 'Small'];
    
    render() {
        var src = 'url(' + this.props.src + ')';
        var size = Utils.checkAvailability(this.availableSizes, this.props.size, true);
        var insideComponent = Utils.checkUsage(this.props.insideComponent);
        
        var classValue = "ProfilePic " + size;
        
        var html = <div className={classValue} style={{backgroundImage: src}}>
        {insideComponent}
        </div>;
        
        return html;
    }
}

export default ProfilePic;
